/**
 * Ảnh sản phẩm + Mô tả sản phẩm của HSNL NCC.
 *
 * Hai API chi tiết của KIOS (quick-search `supplier_profiles/{id}` và TPAT
 * `customer-profiles/{kh}/supplier-profiles/{ma}`) đều KHÔNG trả `image`/`description` — đã đối
 * chiếu thật: hai trường này chỉ có ở API danh sách. Nhưng thiết kế lại yêu cầu khối "Thông tin cơ
 * bản HSNL" ngay trên trang chi tiết.
 *
 * Nên lưu lại khi người dùng bấm xem ở danh sách, rồi trang chi tiết đọc ra. Dùng localStorage chứ
 * không dùng state điều hướng để còn sống sau khi refresh trang.
 *
 * Lưu theo CẢ id lẫn mã CĐS: quick-search điều hướng theo id, TPAT điều hướng theo mã — đọc theo
 * khoá nào cũng ra.
 */
const KEY = 'supplier-extras';
const MAX = 50;

export interface SupplierExtras {
  image?: string | null;
  description?: string | null;
  typeName?: string | null;
}

type Store = Record<string, SupplierExtras>;

const read = (): Store => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}') as Store;
  } catch {
    return {};
  }
};

export const saveSupplierExtras = (s: {
  id?: string | number | null;
  operationCode?: string | null;
  image?: string | null;
  description?: string | null;
  typeName?: string | null;
}): void => {
  try {
    const store = read();
    const value: SupplierExtras = {
      image: s.image,
      description: s.description,
      typeName: s.typeName,
    };
    const keys = [s.id, s.operationCode].filter((k) => k != null && k !== '').map(String);
    if (keys.length === 0) return;

    keys.forEach((k) => {
      const existing = Object.keys(store);
      if (existing.length >= MAX && !store[k]) {
        delete store[existing[0]]; // bỏ bản ghi cũ nhất
      }
      store[k] = value;
    });
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    /* localStorage đầy/không dùng được → bỏ qua, khối ảnh/mô tả chỉ trống chứ không vỡ trang */
  }
};

/** Đọc theo mã CĐS trước rồi tới id — chỗ gọi truyền cả hai, khoá nào có thì dùng. */
export const getSupplierExtras = (
  ...keys: Array<string | number | null | undefined>
): SupplierExtras => {
  const store = read();
  for (const k of keys) {
    if (k == null || k === '') continue;
    const hit = store[String(k)];
    if (hit) return hit;
  }
  return {};
};
